class LogsConnect {
  constructor() {
    // Use environment variables to construct WebSocket URL with port
    const wsUrl = process.env.VUE_APP_BACKEND_SOCKET_URL || 'ws://127.0.0.1';
    const port = process.env.VUE_APP_BACKEND_PORT || 80;
    this.baseUrl = `${wsUrl}:${port}`;
  }

  // Get WebSocket URL for a specific endpoint
  getUrl(endpoint = '') {
    return `${this.baseUrl}${endpoint}`;
  }

  // Connect to WebSocket endpoint
  connect(endpoint = '') {
    return new Promise((resolve, reject) => {
      try {
        const wsUrl = this.getUrl(endpoint);
        const ws = new WebSocket(wsUrl);
        
        ws.onopen = () => {
          resolve(ws);
        };

        ws.onerror = (error) => {
          reject(error);
        };
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default LogsConnect;
